 export default {
  authorizationDetailForm: null,
  authorizationWithoutClaim: null,
  filtersConfiguration: [],
  authorizationDetail: null,
  authorizationLoading: false,
  authorizationForms: [],
  authorizationFormsAndSteps: null,
  currentForm: null,
  currentStep: null,
  error: {},
  stepError: true,
  inputs: [],
  errorAlert: false,
  createAuthorizationAction: null,
  accountsSearchValue: null,
  page: {},
  authorizationRcmAccountInfo: null,
  authorizationSupportFiles: null,
  authorizationSponsorStaticDocuments: null,
  authorizationSponsorStaticDocumentsError: null,
  authorizationPreInvoice: [],
  newAuthorizationStatus: null,
  authorizationInvoice: [],
}
